module.exports = __webpack_public_path__ + "img/walk-outline.66af485f.svg";